<script setup lang="ts">
import { computed } from 'vue'

import type { ComputedHotelImage } from '@revolugo/graphql/private'

const props = defineProps<{
  disabled?: boolean
  // TODO: export IHotelImage, ImageSizeLabel to public graphql schema
  image: ComputedHotelImage
  size: 'l' | 'm' | 's' | 'xl' | 'xs'
}>()

const image = computed(() => props.image[props.size])
</script>

<template>
  <img
    :src="image"
    :class="disabled ? 'disabled' : ''"
    v-bind="$attrs"
  />
</template>

<style scoped lang="scss">
.disabled {
  /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
}
</style>
